/* Keep below-fold collections from competing with the homepage cover image.
 * Native lazy loading still handles individual images once their row is near.
 * The Liquid markup includes the same images in noscript for visitors without JS.
 */
(() => {
  const observed = new WeakSet();
  const reveal = (row) => {
    row.querySelectorAll('template[data-deferred-card-image]').forEach((template) => {
      template.replaceWith(template.content);
    });
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function initialize(root) {
    root.querySelectorAll('template[data-deferred-card-image]').forEach((template) => {
      const row = template.closest('.product-grid') || template.parentElement;
      if (!observer || window.Shopify?.designMode) {
        reveal(row);
      } else if (!observed.has(row)) {
        observed.add(row);
        observer.observe(row);
      }
    });

    root.querySelectorAll('.editorial-hero__slider-wrap').forEach((slider) => {
      if (observed.has(slider)) return;
      observed.add(slider);
      const revealCovers = () => {
        slider.querySelectorAll('template[data-deferred-cover-image]').forEach((template) => {
          template.replaceWith(template.content);
        });
      };
      const firstCover = slider.querySelector('.editorial-hero__img');
      // Fetch the next cover once the visible one has finished, or immediately
      // when the visitor starts using the slider. Keep the first download clear.
      if (firstCover?.tagName !== 'IMG' || firstCover.complete || window.Shopify?.designMode) {
        revealCovers();
      } else {
        firstCover.addEventListener('load', revealCovers, { once: true });
        firstCover.addEventListener('error', revealCovers, { once: true });
      }
      slider.addEventListener('pointerdown', revealCovers, { once: true, passive: true });
      slider.addEventListener('keydown', revealCovers, { once: true });
      slider.addEventListener('slideChanged', revealCovers, { once: true });
    });

    root.querySelectorAll('.editorial-hero__mood').forEach((mood) => {
      if (observed.has(mood)) return;
      observed.add(mood);
      const revealMood = () => {
        mood.querySelectorAll('template[data-deferred-mood-image]').forEach((template) => {
          template.replaceWith(template.content);
        });
      };
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
        revealMood();
      } else {
        const moodObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          revealMood();
          moodObserver.disconnect();
        }, { rootMargin: '250px 0px' });
        moodObserver.observe(mood);
      }
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
